(()=>{'use strict';



document.querySelectorAll('[data-ass-inert]').forEach(a=>a.addEventListener('click',e=>e.preventDefault()));



document.querySelectorAll('a[data-ass-cta]').forEach(a=>{



 if(a.getAttribute('href').startsWith('/products/')){const u=new URL(a.href);for(const[k,v]of new URLSearchParams(location.search)){if(/^(utm_|fbclid$|gclid$|ttclid$|msclkid$)/.test(k))u.searchParams.set(k,v)}a.href=u.pathname+u.search}



 else a.addEventListener('click',e=>{e.preventDefault();document.querySelector('#aera-smoothspine-purchase')?.scrollIntoView({behavior:'smooth',block:'center'})});



});



let availabilityRequest=null;
async function syncAvailability(){
 const form=findPurchaseForm();if(!form)return;const button=form.querySelector('[name=add]'),id=form.querySelector('[name=id]');if(!button||!id)return;
 try{const root=window.Shopify?.routes?.root||'/';if(!availabilityRequest)availabilityRequest=fetch(root+'products/aera-smoothspine-triple-fusion-massager.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(async res=>{if(!res.ok)throw Error('Availability unavailable');return res.json()}).finally(()=>{availabilityRequest=null});const data=await availabilityRequest;if(!form.isConnected||form.dataset.assBusy==='true'||button.getAttribute('aria-busy')==='true')return;const variant=data.variants?.find(v=>String(v.id)===id.value)||data.variants?.find(v=>v.available)||data.variants?.[0];if(!variant)return;id.value=String(variant.id);button.disabled=!variant.available;button.textContent=variant.available?'ADD TO CART':'SOLD OUT';
 }catch{/* Keep Shopify's current availability when a fresh check fails. */}
}
const boundForms=new WeakSet();
function findPurchaseForm(){return document.querySelector('#aera-smoothspine-product-form')||document.querySelector('#aera-smoothspine-purchase form[action*="/cart/add"]')}
function bindPurchaseForm(){const form=findPurchaseForm();if(!form||boundForms.has(form))return;boundForms.add(form);form.addEventListener('submit',async e=>{
 if(form.closest('.ass-purchase')?.querySelector('.shopify-app-block'))return;
 e.preventDefault();const button=form.querySelector('[name=add]'),error=form.querySelector('.ass-error');if(!button||button.disabled||form.dataset.assBusy==='true')return;
 const qty=form.querySelector('[name=quantity]');if(qty&&!qty.checkValidity()){qty.reportValidity();return}
 form.dataset.assBusy='true';button.disabled=true;if(error)error.hidden=true;const label=button.textContent;button.textContent='ADDING…';
 try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});let result;try{result=await response.json()}catch{throw Error('Unable to add to cart. Please try again.')}
 if(!response.ok)throw Error(result.description||result.message||'Unable to add to cart. Please try again.');window.dispatchEvent(new CustomEvent('ass:cart-added'));
 }catch(ex){if(error){error.textContent=ex.message;error.hidden=false}}finally{form.dataset.assBusy='false';button.disabled=false;button.textContent=label}
});}
bindPurchaseForm();syncAvailability();window.addEventListener('pageshow',()=>{bindPurchaseForm();syncAvailability()});document.addEventListener('shopify:section:load',()=>{bindPurchaseForm();syncAvailability()});const purchase=document.querySelector('#aera-smoothspine-purchase');if(purchase)new MutationObserver(bindPurchaseForm).observe(purchase,{childList:true,subtree:true});
const lazy=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{if(target.tagName==='VIDEO'){if(isIntersecting)target.play().catch(()=>{});else target.pause()}}),{rootMargin:'200px'});document.querySelectorAll('video[autoplay]').forEach(v=>{v.muted=true;lazy.observe(v)});



})();



